export default __webpack_public_path__ + "static/media/request-16.84805ad7.png";